import { BusinessActionType, BusinessActions } from '../actions/businessActions';
import { call, put, takeLatest, debounce } from 'redux-saga/effects';
import { Services } from '@card/commonlib';

type BusinessAction = {
  type: string;
  error: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any; // TODO payload type
  meta: undefined;
};

function* fetchBusiness() {
  try {
    // TODO(santi698): Type this correctly, the signature of getCurrentCompany is probably wrong
    const response = yield call(Services.getCurrentCompany);
    // puede venir un array vacio en la respuesta
    const company =
      response.data && response.data.length > 0 ? response.data[0] : { legalName: '' };
    yield put(BusinessActions.fetchSuccess(company));
  } catch (error) {
    yield put(BusinessActions.fetchError(error));
  }
}

function* putNameBusiness(businessAction: BusinessAction) {
  businessAction.payload = {
    summaryForm: { businessName: businessAction.payload }
  };
  try {
    const response = yield call(Services.setBusinessName, businessAction.payload);
    yield put(BusinessActions.putBusinessNameSuccess(response.data));
  } catch (error) {
    yield put(BusinessActions.fetchError(error));
  }
}

function* businessSagas() {
  yield takeLatest(BusinessActionType.Fetch, fetchBusiness);
  yield debounce(500, BusinessActionType.PutName, putNameBusiness);
}

export default businessSagas;
